
import { userConstants } from "../constants/login.constants";

 function individualEntitiesWithPagination(state = {}, action) {
    switch (action.type) {
        case userConstants.INDIVIDUALENTITIESWITHPAGINATION_REQUEST:
            return {
                loading: true
            };
        case userConstants.INDIVIDUALENTITIESWITHPAGINATION_SUCCESS:
            return {
                items: action.individualEntitiesWithPagination
            };
        case userConstants.INDIVIDUALENTITIESWITHPAGINATION_FAILURE:
            return {
                error: action.error
            };
        default:
            return state
    }
}
export default individualEntitiesWithPagination;